module.exports = __webpack_public_path__ + "img/ASSU_logo.f6b74588.png";